import { environment } from '../../../environments/environment';
import type { DeepLinkConfig } from '../models/deep-link.model';

/**
 * Deep Link Configuration
 * Maps custom URL schemes and universal HTTPS links to app routes
 */
const getUniversalLinksDomain = (): string => {
  const webAppDomain = environment.webAppDomain;

  if (!webAppDomain) {
    throw new Error('webAppDomain not configured in environment');
  }

  return webAppDomain.replace(/^https?:\/\//, '');
};

const universalLinksDomain = getUniversalLinksDomain();

export const DEEP_LINK_CONFIG: DeepLinkConfig = {
  routes: [
    {
      scheme: 'smartrexperian',
      path: 'success',
      route: '/open-banking/success',
      replaceUrl: true,
    },
    {
      scheme: 'smartrexperian',
      path: 'error',
      route: '/open-banking/error',
      replaceUrl: true,
    },
    {
      scheme: 'homebuyersmartr365',
      path: 'auth/redirect',
      route: '/auth/redirect',
      replaceUrl: true,
    },
  ],

  universalLinks: [
    {
      domain: universalLinksDomain,
      path: '/',
      route: '/',
    },
    {
      domain: universalLinksDomain,
      path: '/dashboard',
      route: '/dashboard',
    },
    {
      domain: universalLinksDomain,
      path: '/acknowledgements',
      route: '/acknowledgements',
    },
    {
      domain: universalLinksDomain,
      path: '/identity-verification',
      route: '/identity-verification',
    },
    {
      domain: universalLinksDomain,
      path: '/fact-find',
      route: '/fact-find',
    },
    {
      domain: universalLinksDomain,
      path: '/auth/login',
      route: '/auth/login',
    },
    {
      domain: universalLinksDomain,
      path: '/phone-verification',
      route: '/phone-verification',
    },
    {
      domain: universalLinksDomain,
      path: '/auth/not-invited',
      route: '/auth/not-invited',
    },
    {
      domain: universalLinksDomain,
      path: '/invite',
      route: '/',
    },
    {
      domain: universalLinksDomain,
      path: '/invite/*',
      route: '/',
    },
  ],
};
